import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  applySavingsFailed: {
    defaultMessage: 'Failed to apply savings',
    description: 'Message shown when applying savings failed',
    id: 'NLdpzu',
  },
});
